import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'

// 通过订单号查询订单信息（对外，无需 token）
export function queryByOrderNo(orderNo) {
  return request({
    url: `${apiConfig.ECS}/platOrderEcs/queryByOrderNo/${encodeURIComponent(orderNo)}`,
    method: 'get'
  })
}
